@let _recipe = recipe();

@if (_recipe) {
  <wc-breadcrumbs [titleRecipe]="_recipe.title" />
}

<div class="recipe-details-page-template">
  <span [wcCxJsonLd]="snippetRecipes()"></span>
  <span [wcCxJsonLd]="snippetImages()"></span>
  <span [wcCxJsonLd]="snippetVideos()"></span>

    <wc-recipe-overview
      #recipeOverviewComponent
      [recipe]="_recipe"
      [brand]="brandCorner"
      [isLoading]="useLazyLoad && !hasOverviewLoaded"
      (updateYield)="onUpdateYield($event)"
      (reviewsClicked)="scrollToReviews($event)"
      (printClicked)="print()"
      (hasLoaded)="onOverviewLoaded()"
    />

    <section>
      <cx-page-slot position="Body2" />
    </section>

    <section>
      <cx-page-slot position="Body3" />
    </section>

    @if (seo(); as _seo) {
      @if (_seo?.paragraphs?.length > 0) {
        <sd-seo-wrapper [data]="_seo" [brand]="brandCorner" />
      }
    }

    @if (similarRecipeCards(); as _similar) {
      @if (_similar.length) {
        <aside>
          <wc-recipe-slider [recipeCards]="_similar" [brand]="brandCorner" />
        </aside>
      }
    }

    @if (_recipe) {
      <section>
        <wc-recipe-reviews #recipeReviewsComponent
                           id="reviews"
                           [recipe]="_recipe"
                           (hasLoaded)="onRecipeReviewLoaded()"
        />
      </section>
    }

    <!-- SEO slot -->
    <section>
      <cx-page-slot position="SEO" />
    </section>
</div>
